import React from "react";
import { Card, Typography } from "antd";
const { Title, Text } = Typography;

export const MyHeader = ({
  children,
  level = 3,
  mainTitle = "",
  childrenInHeader = () => {},
  secondaryText = false,
  btnHeader = () => {},
}) => {
  return (
    <Card
      style={{
        marginBottom: 16,
        borderRadius: 16,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          justifyContent: "space-between",
        }}
      >
        <Title level={level} style={{ margin: 0 }}>
          {mainTitle}
        </Title>
        {childrenInHeader?.()}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "10px",
          alignItems: "center",
        }}
      >
        {secondaryText && <Text type="secondary">{secondaryText}</Text>}
        {btnHeader?.()}
      </div>

      {children}
    </Card>
  );
};
